export default {
  messages: [],
  maxMessageID: 0,
  statusBar: {},
  /*
   * hide_footer: boolean,
   * hide_header: boolean,
   * hide_progress_bar: boolean
   * */
  layoutConfig: {},

  customThemeOptions: {},
  selectedTheme: 'basic',
  availableLocales: null,
  queryLocale: null,
};
